module.exports = __webpack_public_path__ + "media/images/common/guide_btn_ov-804b46321e47f0de4a2c215158f3ac76.gif";